module.exports = __webpack_public_path__ + "media/images/logo/vzvz_new-19e86b188303da9219c0353fb5b3888b.svg";